import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Global } from 'src/app/config/config';
import { ApiResponse } from 'src/app/models/api-response';
import { Usuario } from 'src/app/models/catalogos/usuario';
import { MenuSesion } from 'src/app/models/menu-sesion';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient, private router: Router) { }

  login(form?: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(Global.URL_API + 'login', form);
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  getToken(): string {
    return localStorage.getItem('token');
  }

  getMenu(): MenuSesion[] {
    return localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : [];
  }

  saveSession(data: any): Observable<boolean> {
    if (data) {
      localStorage.setItem('userSession', JSON.stringify(data.user));
      localStorage.setItem('menu', JSON.stringify(data.menu));
      localStorage.setItem('permisos', JSON.stringify(data.permisos));
      localStorage.setItem('cajeros', JSON.stringify(data.cajeros));

      // let permisos = await this.permisosService.getPermisosUser().toPromise() as Permisos[];
      // localStorage.setItem('permisos', JSON.stringify(permisos));
      // this.bitacora.escribe("Inicio de sesión");
      return of(true);
    }
    else {
      return of(false);
    }
  }

  isAuthenticated() {
    if (localStorage.getItem('userSession') !== null)
      return true;
    else
      return false;
  }

  async expiredToken(): Promise<boolean> {
    let expiredToken = true;
    
    try {
      const validity = await this.http.post(Global.URL_API + "users/validity", { token: JSON.parse(localStorage.getItem('userSession') || '').token }).toPromise() as any;
     
      
      // if (<boolean>validity.data.tokenExpired == false) {
      //   localStorage.removeItem('permisos');
      //   localStorage.setItem('permisos', JSON.stringify(validity.data.permisos));
      // }
      expiredToken = validity.data.tokenExpired as boolean;
    }
    catch (err) {
      expiredToken = true;
    }
    return expiredToken;
  }

  logout() {
    let user = JSON.parse(localStorage.getItem('userSession') || '');
    user.logueo = false;
    localStorage.clear(); //temporalmente
    this.router.navigate(['/login']);
  }

  private getSessionData(): Usuario {
    return localStorage.getItem('userSession') ? JSON.parse(localStorage.getItem('userSession')) : null;
  }

  getUserSessionData(key: string) {
    let data = this.getSessionData();
    return data[key];
  }
}
